import React, {ReactNode} from 'react';
import {noop} from '../../../utils/Utils';
import Icon from '../../icon/Icon';
import {onEnterOrSpace} from '../../../utils/Accessibility';
import DynamicTag from '../../../utils/DynamicTag';
import {ListViewItemAffix, ListViewItemDecoration} from './ListViewItem.types';

export interface ListViewItemPrimaryButtonProps {
  title: string | ReactNode;
  ariaLabel?: string;
  iconCategory?: string;
  decoration?: ListViewItemDecoration;
  topAffix?: ListViewItemAffix;
  bottomAffix?: ListViewItemAffix;
  hoverColor?: string;
  onClick?: () => void;
}

const ListViewItemPrimaryButton: React.FC<ListViewItemPrimaryButtonProps> = (
    {
      title,
      ariaLabel,
      iconCategory,
      decoration,
      topAffix,
      bottomAffix,
      hoverColor,
      onClick
    }) => {

  function renderIcon(): ReactNode {
    return iconCategory && (
        <div className="listview-item__icon">
          <Icon category={iconCategory}/>
        </div>
    );
  }

  function renderDecoration(): ReactNode {
    return decoration && (
        <div className="listview-item__decoration">
          <Icon category={decoration.icon}
                size={decoration.size}
                ariaLabel={decoration.ariaLabel}/>
        </div>
    );
  }

  function renderTopAffix(): ReactNode {
    return topAffix && (
        <div className="listview-item__affix viewview-item__affix--top">{topAffix.label}</div>
    );
  }

  function renderBottomAffix(): ReactNode {
    return bottomAffix && (
        <div className="listview-item__affix listview-item__affix--bottom">{bottomAffix.label}</div>
    );
  }

  function renderContent(): ReactNode {
    return (
        <div className="listview-item__content">
          {title}
        </div>
    );
  }

  function getPrimaryButtonClassNames(): string[] {
    const classNames = [];

    const isInteractive = onClick != null;
    if (isInteractive) {
      classNames.push('listview-item__button', 'listview-item__button--primary');
      if (hoverColor) {
        classNames.push('listview-item__button--hover-' + hoverColor);
      }
    } else {
      classNames.push('listview-item__label');
    }
    return classNames;
  }

  function getPrimaryButtonProps(): any {
    const isInteractive = onClick != null;
    return {
      tag:          isInteractive ? 'button' : 'div',
      className:    getPrimaryButtonClassNames().join(' '),
      'aria-label': ariaLabel,
      onClick:      () => (onClick ?? noop)(),
      onKeyPress:   (event: React.KeyboardEvent) => onEnterOrSpace(event, () => (onClick ?? noop)())
    };
  }

  return <DynamicTag {...getPrimaryButtonProps()}>
    <div className="listview-item__decoration-wrapper">
      {renderIcon()}
      <div className="listview-item__content-wrapper">
        {renderTopAffix()}
        {renderContent()}
        {renderBottomAffix()}
      </div>
      {renderDecoration()}
    </div>
  </DynamicTag>;
};

export default ListViewItemPrimaryButton;
